<template>
	<div>
		<Card dis-hover style="height: 85vh;">
			<Divider orientation="left"><b>称重框管理</b></Divider>
			<Row :gutter="40">
				<Col :span="6" style="margin-top: 30px;">
					<Button icon="md-add" long type="success" size="large" @click="showCreateModal">添加</Button>
				</Col>
				<Col :span="6" v-for="(item,index) of turnoverList" :key="index" style="margin-top: 30px;">
					<Button long size="large" @click="showUpdateModal(item)">{{item.title}}{{unitValue(item.box_weight)}}</Button>
				</Col>
			</Row>
		</Card>
		<Modal v-model="showModal" footer-hide :width="750">
			<div slot="header"><b>编辑称重框</b></div>
			<Form :label-width="130" ref="from" :model="turnoverInfo" :rules="formRule" :hide-required-mark="true">
				<FormItem prop="title" label="">
					<div slot="label">称重框名称：</div>
					<Input placeholder="请输入称重框名称" size="large" style="width: 300px;" v-model="turnoverInfo.title" :maxlength="20"/>
				</FormItem>
				<br/>
				<FormItem prop="box_weight">
					<div slot="label">称重框重量：</div>
					<InputNumber placeholder="请输入称重框重量" controls-outside :min="0" size="large" style="width: 300px;"
					             v-model="turnoverInfo.box_weight"/>
					<span>{{unitValue(-1)}}</span>
				</FormItem>
			</Form>
			<br/>
			<div v-if="!turnoverInfo.id">
				<Button size="large" long icon="md-checkmark-circle" type="primary" @click="saveCreateTurnover">确认创建</Button>
			</div>
			<div v-else>
				<Button size="large" icon="md-trash" style="width: 48%;" type="warning" @click="showDeleteModal">删除</Button>
				<Button size="large" icon="md-checkmark-circle" style="width: 50%;" type="primary" @click="saveUpdateTurnover">
					确认
				</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {queryTurnoverBoxList, createTurnover} from "@/api/sorting/turnoverBox"
  import {changeUnit} from "@/libs/util";
	export default {
		name: "turnoverList",
		components: {},
		data() {
			return {
				// 称重框列表
				turnoverList: [],
				// 称重框信息
				turnoverInfo: {
					title: "",
					box_weight: 1
				},
				formRule: {
					title: {required: true, message: '请输入称重框名称', trigger: 'blur'},
					box_weight: {required: false, type: "number", min: 0, message: '请输入称重框重量', trigger: 'blur'},
				},
				// 创建窗口
				showModal: false,
			};
		},
		methods: {
			// 查询周转物
			queryTurnoverBoxList() {
				queryTurnoverBoxList({rows: 100, box_type: 2, selfCreate: 1}).then(data => {
					if (data.status === 200) {
						if (data.data.code == 1200) {
							this.turnoverList = data.data.data.rows;
						} else {
							this.$Message.error(data.data.msg);
						}
					}
				});
			},
			// 打开创建弹窗
			showCreateModal() {
				this.showModal = true;
				delete this.turnoverInfo.id;
				this.$refs.from.resetFields();
			},
			// 创建保存
			async saveCreateTurnover() {
				let valid = await this.$refs["from"].validate();
				if (!valid) return;
				let param = {...this.turnoverInfo};
        let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
        param.box_weight = unitValue == 1 ? changeUnit(param.box_weight, "斤", "g") : changeUnit(param.box_weight, "kg", "g");
				createTurnover(param).then(data => {
					if (data.status === 200) {
						if (data.data.code == 1200) {
							this.showModal = false;
							this.queryTurnoverBoxList();
							this.$Notice.success({title: "创建成功",})
						} else {
							this.$Message.error(data.data.msg);
						}
					}
				});
			},
			// 打开修改弹窗
			showUpdateModal(data) {
				this.showModal = true;
				this.turnoverInfo.id = data.id;
				this.turnoverInfo.title = data.title;
        let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
				this.turnoverInfo.box_weight = unitValue == 1 ? changeUnit(data.box_weight, "g", "斤") : changeUnit(data.box_weight, "g", "kg");
			},
			// 修改保存
			async saveUpdateTurnover() {
				let valid = await this.$refs["from"].validate();
				if (!valid) return;
				let param = {...this.turnoverInfo};
        let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
				param.box_weight = unitValue == 1 ? changeUnit(param.box_weight, "斤", "g") : changeUnit(param.box_weight, "kg", "g");
				createTurnover(param).then(data => {
					if (data.status === 200) {
						if (data.data.code == 1200) {
							this.showModal = false;
							this.queryTurnoverBoxList();
							this.$Notice.success({title: "修改成功",})
						} else {
							this.$Message.error(data.data.msg);
						}
					}
				});
			},
			// 打开删除弹窗
			showDeleteModal() {
				this.$Modal.confirm({
					title: "确认删除" + this.turnoverInfo.title,
					content:
						"<p></p>",
					onOk: () => {
						this.turnoverInfo.del_status = 2;
						createTurnover(this.turnoverInfo).then(data => {
							if (data.status === 200) {
								if (data.data.code == 1200) {
									this.showModal = false;
									this.queryTurnoverBoxList();
									this.$Notice.success({title: "删除成功",})
								} else {
									this.$Message.error(data.data.msg);
								}
							}
						});
					},
					onCancel: () => {
					}
				});
			},
		},
		computed: {
      //称重单位
      unitValue() {
        return function(box_weight) {
          let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
          if(box_weight == -1) {
            if(unitValue == 1 ){
              return  '斤'
            }
            if(unitValue == 2 ){
              return  'kg'
            }
          } else {
            if(unitValue == 1 ){
              return  ' ' + changeUnit(box_weight, "g", "斤") + '斤'
            }
            if(unitValue == 2 ){
              return  ' ' + changeUnit(box_weight, "g", "kg") + 'kg'
            }
          }
        }
      }
    },
		mounted() {
			this.queryTurnoverBoxList();
		},
		activated() {
			this.queryTurnoverBoxList();
		}
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/system/turnoverList.vue